document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    $(document).on('Searchanise.ResultsUpdated', function() {
      var price_slider = $('.snize-price-range-slider');
      console.log(price_slider.find('.scale > span'));
      
      if (price_slider.length) {
        price_slider.find('.scale > span').each(function() {
          var text = $(this).html().replace('CHF.', '');
          $(this).html(text);
        });
      }
    });
  })(Searchanise.$);
});